import {Component, EventEmitter, Output, ViewEncapsulation, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {SharedDataService} from '@signature-it/ngx-catalogue/services';
import {ProductSolrDTO} from '@signature-it/ngx-catalogue/models';
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";
import * as EntitySelectors from '@signature-it/ngx-entity/store/selectors';
import {GenericConfig} from '@signature-it/ngx-generic/config';
declare let $: any;

@Component({
    selector: 'family-card',
    templateUrl: './family-card.component.html',
    styleUrls: ['./family-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FamilyCardComponent implements OnInit{
    @Input() item: ProductSolrDTO;
    @Input() numFound: number;
    @Output() goTo: EventEmitter<any> = new EventEmitter<any>();
    @Input() mode: string = 'grid';

    previewVar: string = GenericConfig.familyPreviewVar;
    templates$: Observable<any>;
    loadingTpl$: Observable<boolean>;

    constructor( protected router: Router,
                 public sharedSvc: SharedDataService,
                 protected store$: Store<any>) {
        this.templates$ = this.store$.select(EntitySelectors.getPreviews);
        this.loadingTpl$ = this.store$.select(EntitySelectors.getIsLoadingPreviews);

    }

    ngOnInit() {
        this.item['numFound'] = this.numFound;
    }

    goToFamily() {
        this.goTo.emit(this.item);
    }

}
